"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operatorAttendanceTypes = void 0;
exports.operatorAttendanceTypes = {
    SET_ERROR: 'OPERATOR ATTENDANCE TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'OPERATOR ATTENDANCE TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'OPERATOR ATTENDANCE TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'OPERATOR ATTENDANCE TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'OPERATOR ATTENDANCE TYPES ON MUTATION',
    ON_FILTER_CHANGE: 'OPERATOR ATTENDANCE TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'OPERATOR ATTENDANCE TYPES ON SAVE DATAITEM',
    ON_CHANGE_DATAITEM: 'OPERATOR ATTENDANCE TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'OPERATOR ATTENDANCE TYPES SET SUCCESS MODAL',
    SET_EXPORT_DOCUMENTS_URL: 'OPERATOR ATTENDANCE TYPES SET EXPORT DOCUMENTS URL',
    CLEAR_EXPORT_DOCUMENTS_URL: 'OPERATOR ATTENDANCE TYPES CLEAR EXPORT DOCUMENTS URL',
};
